// extracted by mini-css-extract-plugin
export default {"radioButton_label":"CsplRadioButton_radioButton_label__CGZ-S"};